"use client";
import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TopNavThree from "../../components/Header/TopNav/TopNavThree";
import MenuFurniture from "../../components/Header/Menu/MenuFurniture";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import Footer from "../../components/Footer/Footer";
import { useCart } from "../../context/CartContext";
import { useSearchParams } from "react-router-dom";
import { fetchProductImages, fetchProductText } from "../../data/Productlist";
import axios from "axios";
import success from "../../utils/success";
import warning from "../../utils/warning";
import * as Icon from "@phosphor-icons/react/dist/ssr";
import { generateOrderNumber } from "../../utils/orderUtils";
import { PromoCodeInput } from "../../components/PromoCode";
import { PromoCode, validatePromoCode, applyPromoCode } from "../../utils/promoUtils";
import { getApiUrl } from "../../config/api";
import { makeCartVariantKey } from "../../utils/cartVariantKey";
import { tiktokTrackOrderPlaced, tiktokInitiateCheckout, tiktokAddPaymentInfo, getTikTokAttribution } from "../../utils/tiktokPixel";
import { metaTrackOrderPlaced, metaInitiateCheckout, metaAddPaymentInfo, getMetaAttribution, metaGenerateEventId } from "../../utils/metaPixel";
import { analyticsOrderConverted } from "../../utils/analytics";
import {
  cartQualifiesForDeliveryPromo,
  resolveCheckoutShippingFee,
} from "../../utils/deliveryPromo";

const checkoutCompleteMarkClass =
  "flex shrink-0 items-center justify-center rounded-full border-2 border-green-500 bg-green-100 text-green-600";

const CheckoutStep: React.FC<{
  step: number;
  title: string;
  subtitle?: string;
  icon: React.ReactNode;
  isComplete: boolean;
  children: React.ReactNode;
}> = ({ step, title, subtitle, icon, isComplete, children }) => (
  <div
    className={`rounded-xl border-2 p-4 md:p-5 transition-all duration-300 ${
      isComplete
        ? "border-green-400 bg-green-50/40 shadow-[0_4px_16px_-8px_rgba(34,197,94,0.35)]"
        : "border-pink/40 bg-pink-50/60 shadow-[0_4px_20px_-8px_rgba(255,67,112,0.35)]"
    }`}
  >
    <div className="mb-3 flex items-start gap-3">
      <span
        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-base font-bold transition-colors duration-300 md:h-9 md:w-9 md:text-sm ${
          isComplete
            ? `${checkoutCompleteMarkClass} h-10 w-10 md:h-9 md:w-9`
            : "bg-pink text-white"
        }`}
        aria-hidden
      >
        {isComplete ? <Icon.Check size={22} weight="bold" className="text-green-600" /> : step}
      </span>
      <div className="min-w-0 flex-1 pt-0.5">
        <div className="flex items-center gap-2">
          <span className={isComplete ? "text-green-600" : "text-pink"}>{icon}</span>
          <h3 className={`text-base font-semibold md:text-sm ${isComplete ? "text-green-800" : "text-title"}`}>
            {title}
          </h3>
          {isComplete ? (
            <span className="ml-auto flex shrink-0 items-center gap-1 rounded-full border border-green-500 bg-green-100 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-green-700">
              <Icon.Check size={12} weight="bold" className="text-green-600" />
              OK
            </span>
          ) : (
            <span className="ml-auto shrink-0 rounded-full bg-pink/15 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-pink">
              À remplir
            </span>
          )}
        </div>
        {subtitle ? (
          <p className={`mt-1 text-sm leading-snug md:text-xs ${isComplete ? "text-green-700/80" : "text-secondary"}`}>
            {subtitle}
          </p>
        ) : null}
      </div>
    </div>
    {children}
  </div>
);

const CheckoutFieldWrapper: React.FC<{
  isComplete: boolean;
  children: React.ReactNode;
}> = ({ isComplete, children }) => (
  <div className="relative">
    {children}
    {isComplete && (
      <span
        className={`pointer-events-none absolute right-3 top-1/2 h-8 w-8 -translate-y-1/2 ${checkoutCompleteMarkClass} shadow-sm`}
        aria-hidden
      >
        <Icon.Check size={18} weight="bold" className="text-green-600" />
      </span>
    )}
  </div>
);

const Checkout = () => {
  document.title = "Paiement | Kissaira"
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Add navigation state tracking
  const [isNavigating, setIsNavigating] = useState(false);
  const [hasInitialized, setHasInitialized] = useState(false);

  useEffect(() => {
    // Mark as initialized after component mounts
    setHasInitialized(true);
    
    // Handle browser back/forward navigation
    const handleBeforeUnload = () => {
      setIsNavigating(true);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  // Handle location changes
  useEffect(() => {
    if (hasInitialized) {
      setIsNavigating(false);
      // Ensure proper scroll position
      window.scrollTo(0, 0);
    }
  }, [location.pathname, hasInitialized]);

  let discount = searchParams.get("discount");
  let ship = searchParams.get("ship");
  const [livraison, setlivraison] = useState<{ city: string,standard:number,express:number,id:number }[]>([]);
  const [city, setCity] = useState<string>("")
  const [prix, setPrix] = useState<number>(0)

  const [deliveryType, setDeliveryType] = useState<string>('')
  const [deliveryPromoProductIds, setDeliveryPromoProductIds] = useState<Set<string>>(new Set())
  const [baseShippingFee, setBaseShippingFee] = useState<number>(0)


  const { cartState } = useCart();
  let [totalCart, setTotalCart] = useState<number>(0);
  const [activePayment, setActivePayment] = useState<string>(
    "paiement à la livraison"
  );
  const [expressavailable, setexpressavailable] = useState<boolean>();
  const [promoCode, setPromoCode] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  cartState.cartArray.map((item) => (totalCart += item.price * item.quantity));

  const handlePayment = (item: string) => {
    setActivePayment(item);
    if (cartDetails.length === 0) return;
    const subtotal = cartDetails.reduce(
      (sum, row) => sum + Number(row.price || 0) * Number(row.quantityPursh || 1),
      0
    );
    tiktokAddPaymentInfo({
      value: subtotal - promoDiscount + prix,
      contents: cartDetails.map((row) => ({
        content_id: String(row.id),
        content_name: String(row.name || ""),
        content_type: "product",
        quantity: Number(row.quantityPursh || 1),
        price: Number(row.price || 0),
      })),
    });
    metaAddPaymentInfo({
      value: subtotal - promoDiscount + prix,
      contents: cartDetails.map((row) => ({
        content_id: String(row.id),
        content_name: String(row.name || ""),
        content_type: "product",
        quantity: Number(row.quantityPursh || 1),
        price: Number(row.price || 0),
      })),
    });
  };

  const [dataSourceProd, setDataSourceProd] = useState<any[]>([]);
  const [isOpenProduct, setisOpenProduct] = useState(true);
  const [isLoadingText, setIsLoadingText] = useState(true);
  const [isLoadingImages, setIsLoadingImages] = useState(true);

  const fetchData = async () => {
    try {
      // Fetch text data first
      const products = await fetchProductText();

      // Set text data first (without images)
      setDataSourceProd(products);
      setisOpenProduct(false);
      setIsLoadingText(false); // Text data loaded

      // Fetch images for the products after the text data is loaded
      const productsWithImages = await fetchProductImages(products);

      // Set the updated products with images
      setDataSourceProd(productsWithImages);

      setIsLoadingImages(false); // Images data loaded
    } catch (error) {
      console.error("Failed to fetch products: ", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [cartDetails, setCartDetails] = useState<any[]>([]);
  const [cartDataLoaded, setCartDataLoaded] = useState(false);
  const [colorImages, setColorImages] = useState<{[key: number | string]: string}>({});

  const fetchColorImage = async (imageid: number | string) => {
    if (!imageid || colorImages[imageid]) return; // Already loaded or no imageid
    
    // Use direct path instead of API call
    const imagePath = `/images/${imageid}`;
    setColorImages(prev => ({
      ...prev,
      [imageid]: imagePath
    }));
  };

  const updateCartDetails = async () => {
    const cartItemsJSON = localStorage.getItem("cartItems");
    const cartItems: any[] = cartItemsJSON ? JSON.parse(cartItemsJSON) : [];

    // Build cart lines from cartItems so same product can appear multiple times
    // with different color/size/pointure.
    const updatedCartDetails = cartItems
      .map((cartItem) => {
        const product = dataSourceProd.find(
          (p) => Number(p.id) === Number(cartItem.id)
        );
        if (!product) return null;

        const variantKey = makeCartVariantKey({
          productId: cartItem.id,
          colorCode: cartItem.colorCode,
          sizeCode: cartItem.sizeCode,
          pointureCode: cartItem.pointureCode,
        });

        return {
          ...product,
          variantKey,
          quantityPursh: cartItem.quantity ?? 0,
          colorPursh: cartItem.color ?? "pas sélectionné",
          sizePursh: cartItem.size ?? "pas sélectionné",
          pointurePursh: cartItem.pointure ?? "pas sélectionné",
          colorCode: cartItem.colorCode ?? "pas sélectionné",
          sizeCode: cartItem.sizeCode ?? "pas sélectionné",
          colorImageId: cartItem.colorImageId ?? null,
          pointureCode: cartItem.pointureCode ?? "pas sélectionné",
          livraison: cartItem.livraison ?? "pas sélectionné",
        };
      })
      .filter(Boolean) as any[];

    // Set the updated cart details state
    setCartDetails(updatedCartDetails);
    setCartDataLoaded(true);

    // Set color images directly from cart data (only for products with characteristics)
    for (const product of updatedCartDetails) {
      if (product.colorImageId && !product.colorImageId.includes('.') && !product.colorImageId.startsWith('/')) {
        // Only fetch if it's a numeric ID (not a filename like "59-2.jpg")
        fetchColorImage(product.colorImageId);
      }
    }
  };
  useEffect(() => {
    const fetchCaracteristiques = async () => {
        try {
          const response = await fetch(getApiUrl('LIVRAISON'));
          const data = await response.json(); 
          setlivraison(data); 
        } catch (error) {
          console.error('Error fetching product characteristics:', error);
        }
    }
    fetchCaracteristiques()
  },[]);

  useEffect(() => {
    const fetchDeliveryPromo = async () => {
      try {
        const response = await fetch(getApiUrl('DELIVERY_PROMO'));
        const data = await response.json();
        const ids = Array.isArray(data?.product_ids) ? data.product_ids : [];
        setDeliveryPromoProductIds(new Set(ids.map((id: string | number) => String(id))));
      } catch (error) {
        console.error('Error fetching delivery promo products:', error);
      }
    };
    fetchDeliveryPromo();
  }, []);

  useEffect(() => {
    // Initialize the cart details on component mount
    updateCartDetails();

    // Set up an interval to update cart details every 2 seconds
    const intervalId = setInterval(updateCartDetails, 2000);

    // Clear the interval on component unmount
    return () => clearInterval(intervalId);
  }, [dataSourceProd]);

  // Redirect to cart if cart is empty
  useEffect(() => {
    // Only check after data has been loaded and component is initialized
    if (hasInitialized && dataSourceProd.length > 0 && cartDataLoaded) {
      // Add a small delay to ensure all data is properly loaded
      const timeoutId = setTimeout(() => {
        // Check both cartDetails and localStorage to ensure accuracy
        const cartItemsJSON = localStorage.getItem("cartItems");
        const cartItems = cartItemsJSON ? JSON.parse(cartItemsJSON) : [];
        
        if (cartItems.length === 0 && cartDetails.length === 0) {
          console.log("Cart is empty, redirecting to cart page");
          navigate('/cart');
        } else {
          console.log("Cart has items:", cartItems.length, "cartDetails:", cartDetails.length);
        }
      }, 1000); // Wait 1 second for data to load

      return () => clearTimeout(timeoutId);
    }
  }, [cartDetails.length, hasInitialized, dataSourceProd.length, cartDataLoaded, navigate]);

  const calculateTotalPrice = () => {
    return cartDetails.reduce((total, product) => {
      return total + product.price * product.quantityPursh;
    }, 0);
  };

  useEffect(() => {
    const total = calculateTotalPrice();
    setTotalCart(total);
  }, [cartDetails]);

  const [fullName, setFullName] = useState("");
  const [Tel, setTel] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Prevent scrolling when submitting order
  useEffect(() => {
    if (isSubmitting) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isSubmitting]);

  // Promo code state
  const [appliedPromoCode, setAppliedPromoCode] = useState<PromoCode | null>(null);
  const [promoDiscount, setPromoDiscount] = useState<number>(0);
  const [showPromoSuccess, setShowPromoSuccess] = useState(false);
  const [showPromoError, setShowPromoError] = useState(false);
  const [promoMessage, setPromoMessage] = useState('');
  const hasSelectedVariantValue = (value: unknown) => {
    if (value === null || value === undefined) return false;
    const str = String(value).trim().toLowerCase();
    return str !== "" && str !== "pas sélectionné" && str !== "0";
  };

  // Promo code handlers
  const handlePromoCodeApplied = (discount: number, promoCode: PromoCode) => {
    setAppliedPromoCode(promoCode);
    setPromoDiscount(discount);
    setPromoMessage(`Code promo ${promoCode.code} appliqué ! Économisez ${discount.toFixed(2)} MAD`);
    // If promo code is free shipping, set shipping to 0
    if (promoCode.type === 'free_shipping') {
      setPrix(0);
    }
    setShowPromoSuccess(true);
    // Hide success message after 4 seconds
    setTimeout(() => {
      setShowPromoSuccess(false);
    }, 4000);
  };

  const handlePromoCodeRemoved = () => {
    setAppliedPromoCode(null);
    setPromoDiscount(0);
    setPromoMessage('Code promo supprimé');
    setShowPromoSuccess(true);
    if (deliveryType) {
      setPrix(
        resolveCheckoutShippingFee(
          baseShippingFee,
          cartDetails,
          deliveryPromoProductIds,
          false
        )
      );
    }
    setTimeout(() => {
      setShowPromoSuccess(false);
    }, 3000);
  };

  const handleApplyPromoCode = async () => {
    if (!promoCode.trim()) {
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const validation = await validatePromoCode(
        promoCode.trim(),
        totalCart,
        undefined, // userId
        cartDetails.map(item => Number(item.id)),
        cartDetails.map(item => item.category).filter(Boolean)
      );

      if (validation.isValid && validation.promoCode) {
        const result = applyPromoCode(validation.promoCode, totalCart, prix);
        handlePromoCodeApplied(result.discount, validation.promoCode);
        setPromoCode('');
      } else {
        setError(validation.message || 'Code promo invalide.');
      }
    } catch (error) {
      console.error('Error applying promo code:', error);
      setError('Erreur lors de l\'application du code promo.');
    } finally {
      setIsLoading(false);
    }
  };

  const submitOrder = async (e: React.FormEvent<HTMLFormElement>) => {

    e.preventDefault();

    // Prevent duplicate submissions
    if (isSubmitting) {
      console.log("Order submission already in progress, ignoring duplicate request");
      return;
    }

    if (cartDetails.length <= 0) {
      warning("Votre panier est vide.");
      return;
    }

    // Validate required fields
    if (fullName.trim() === "") {
      warning("Veuillez saisir votre nom complet.");
      return;
    }

    if (Tel.trim() === "") {
      warning("Veuillez saisir votre numéro de téléphone.");
      return;
    }

    // Validate phone number format (only numbers and + symbol)
    const phoneRegex = /^[+]?[0-9\s\-\(\)]+$/;
    if (!phoneRegex.test(Tel)) {
      warning("Le numéro de téléphone ne doit contenir que des chiffres et le symbole '+' si nécessaire.");
      return;
    }

    // Remove all non-digit characters except + for length check
    const cleanPhone = Tel.replace(/[^\d+]/g, '');
    if (cleanPhone.length < 8) {
      warning("Le numéro de téléphone doit contenir au moins 8 chiffres.");
      return;
    }

    if (city === "") {
      warning("Veuillez sélectionner une ville.");
      return;
    }

    if (deliveryType === "") {
      warning("Veuillez sélectionner une ville pour la livraison.");
      return;
    }

    setIsSubmitting(true);

    try {
      const clientData = {
        fullName,
        Tel,
        email: "",
      };

      console.log("Sending client data:", clientData);

      let clientResponse;
      try {
        clientResponse = await axios.post(
          getApiUrl('ORDER_CLIENT'),
        clientData
      );

        console.log("Client response:", clientResponse.data);
      } catch (error: any) {
        console.log("Client error response:", error.response?.data);
        console.log("Client error status:", error.response?.status);
        throw error;
      }

      if (clientResponse.data && clientResponse.data.id_client) {
        const id_client = clientResponse.data.id_client;

        // Generate order number once and reuse it
        const generatedOrderNumber = generateOrderNumber();
        console.log("Generated order number:", generatedOrderNumber);

        // Log the colorImageId values for debugging
        console.log("Cart details with colorImageId:", cartDetails.map(item => ({
          id: item.id,
          name: item.name,
          colorImageId: item.colorImageId,
          color: item.colorPursh
        })));

        const { ttclid, ttp } = getTikTokAttribution();
        const { fbp, fbc } = getMetaAttribution();
        const orderData = {
          code_article: cartDetails.map((item) => item.id),
          quantité_article: cartDetails.map((item) => item.quantityPursh),
          statuts: "En attente",
          mode_paiement: activePayment,
          id_client: id_client,
          prix_livraison: prix,
          addresse: "",
          type_livraison:deliveryType,
          total:totalCart-promoDiscount+prix,
          num_commande: generatedOrderNumber,
          city:city,
          couleur: cartDetails.map((item) => item.colorCode),
          size: cartDetails.map((item) => item.sizeCode),
          pointure: cartDetails.map((item) => item.pointureCode),
          imageid: cartDetails.map((item) => item.colorImageId || null), // Add selected color image IDs
          timestamp: new Date().toISOString(),
          local_time: new Date().toLocaleString('fr-FR', { timeZone: 'Europe/Paris' }),
          promo_code: appliedPromoCode?.code || null,
          promo_discount: promoDiscount,
          subtotal: totalCart,
          ttclid: ttclid || null,
          ttp: ttp || null,
          fbp: fbp || null,
          fbc: fbc || null,
          page_url: typeof window !== "undefined" ? window.location.href.split("#")[0] : null,
        };

        console.log("Order data with imageid:", orderData);
        
        
        let orderResponse;
        try {
          orderResponse = await axios.post(
            getApiUrl('COMMANDES'),
          orderData
        );
        } catch (error: any) {
          console.log("Order error response:", error.response?.data);
          console.log("Order error status:", error.response?.status);
          throw error;
        }

        if (orderResponse.data.success) {
          console.log("Full order response:", orderResponse);
          console.log("Order response data:", orderResponse.data);
          console.log("Order response data keys:", Object.keys(orderResponse.data));
          
          // Record promo code usage if a promo code was applied
          if (appliedPromoCode && promoDiscount > 0) {
            try {
              console.log("Recording promo code usage:", appliedPromoCode.code);
              const promoUsageResponse = await axios.post(
                getApiUrl('PROMO_RECORD_USAGE'),
                {
                  promoCodeId: appliedPromoCode.id,
                  userId: id_client,
                  orderId: orderResponse.data.id || orderResponse.data.num_commande || generatedOrderNumber,
                  discount: promoDiscount
                }
              );
              console.log("Promo code usage recorded:", promoUsageResponse.data);
            } catch (error) {
              console.error("Error recording promo code usage:", error);
              // Don't fail the order if promo code recording fails
            }
          }
          
          // Always use our generated order number to maintain consistent format
          let orderNumber = generatedOrderNumber;
          
          console.log("Using generated order number:", orderNumber);

          // Prepare cart details for confirmation page
          const cartDetailsForConfirmation = cartDetails.map(item => ({
            id: item.id,
            name: item.name,
            quantity: item.quantityPursh,
            price: item.price,
            total: item.price * item.quantityPursh,
            color: item.colorPursh,
            size: item.sizePursh,
            pointure: item.pointurePursh
          }));

          const orderValue = totalCart - promoDiscount + prix;
          await tiktokTrackOrderPlaced({
            orderId: String(orderNumber),
            value: orderValue,
            phone: Tel || undefined,
            externalId: String(id_client),
            contents: cartDetailsForConfirmation.map((item) => ({
              content_id: String(item.id),
              content_name: item.name,
              content_type: "product",
              quantity: item.quantity,
              price: item.price,
            })),
          });
          metaTrackOrderPlaced({
            orderId: String(orderNumber),
            value: orderValue,
            phone: Tel || undefined,
            externalId: String(id_client),
            contents: cartDetailsForConfirmation.map((item) => ({
              content_id: String(item.id),
              content_name: item.name,
              content_type: "product",
              quantity: item.quantity,
              price: item.price,
            })),
          });

          analyticsOrderConverted(String(orderNumber));

          setFullName("");
          setTel("");
          localStorage.clear();

          // Navigate to confirmation page with order number and cart details
          console.log("Navigating to order confirmation with order number:", orderNumber);
          const cartDetailsParam = encodeURIComponent(JSON.stringify(cartDetailsForConfirmation));
          const totalParam = encodeURIComponent((totalCart + prix).toString());
          const shippingFeeParam = encodeURIComponent(prix.toString());
          const promoCodeParam = encodeURIComponent(appliedPromoCode?.code || '');
          const promoDiscountParam = encodeURIComponent(promoDiscount.toString());
          
          navigate(`/order-confirmation?orderNumber=${orderNumber}&paymentMethod=${encodeURIComponent(activePayment)}&deliveryMethod=${encodeURIComponent(deliveryType)}&city=${encodeURIComponent(city)}&telephone=${encodeURIComponent(Tel)}&fullName=${encodeURIComponent(fullName)}&cartDetails=${cartDetailsParam}&total=${totalParam}&shippingFee=${shippingFeeParam}&promoCode=${promoCodeParam}&promoDiscount=${promoDiscountParam}`);

        } else {
          console.log("Order submission failed:", orderResponse.data);
          warning("Impossible de passer la commande, veuillez réessayer.");
        }
      }
    } catch (error: any) {
      console.error("Error submitting order:", error);
      
      // Provide more specific error messages
      let errorMessage = "Il y a eu une erreur lors de la soumission de votre commande. Veuillez réessayer.";
      
      if (error.response?.status === 500) {
        errorMessage = "Erreur serveur. Veuillez réessayer dans quelques instants.";
      } else if (error.response?.status === 400) {
        errorMessage = "Données de commande incomplètes. Veuillez vérifier vos informations.";
      } else if (error.code === 'NETWORK_ERROR' || error.message?.includes('Network Error')) {
        errorMessage = "Problème de connexion. Veuillez vérifier votre connexion internet et réessayer.";
      }
      
      warning(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };
  const hasFreeShippingPromoCode =
    Boolean(appliedPromoCode && appliedPromoCode.type === 'free_shipping');
  const deliveryPromoActive = cartQualifiesForDeliveryPromo(
    cartDetails,
    deliveryPromoProductIds
  );

  function delivery(type: string, pri: number) {
    const base = Number(pri) || 0;
    setDeliveryType(type);
    setBaseShippingFee(base);
    setPrix(
      resolveCheckoutShippingFee(
        base,
        cartDetails,
        deliveryPromoProductIds,
        hasFreeShippingPromoCode
      )
    );
  }

  useEffect(() => {
    if (!deliveryType) return;
    setPrix(
      resolveCheckoutShippingFee(
        baseShippingFee,
        cartDetails,
        deliveryPromoProductIds,
        hasFreeShippingPromoCode
      )
    );
  }, [
    cartDetails,
    deliveryPromoProductIds,
    deliveryType,
    baseShippingFee,
    hasFreeShippingPromoCode,
  ]);

  useEffect(() => {
    const livraisonType = cartDetails.filter((e) => e.livraison == 'Express_non');
    setexpressavailable(livraisonType.length > 0);
  }, [cartDetails]);

  const prevCityRef = useRef("");
  useEffect(() => {
    if (!city || city === prevCityRef.current) return;
    prevCityRef.current = city;
    const cityData = livraison.find((e) => e.city === city);
    if (cityData) {
      delivery("standard", cityData.standard);
    }
  }, [city, livraison]);

  const initiateCheckoutTracked = useRef(false);
  const metaInitiateCheckoutEventId = useRef<string | null>(null);
  useEffect(() => {
    if (initiateCheckoutTracked.current || cartDetails.length === 0) return;
    initiateCheckoutTracked.current = true;
    if (!metaInitiateCheckoutEventId.current) {
      metaInitiateCheckoutEventId.current =
        metaGenerateEventId("InitiateCheckout");
    }
    const subtotal = cartDetails.reduce(
      (sum, item) => sum + Number(item.price || 0) * Number(item.quantityPursh || 1),
      0
    );
    tiktokInitiateCheckout({
      value: subtotal - promoDiscount + prix,
      contents: cartDetails.map((item) => ({
        content_id: String(item.id),
        content_name: String(item.name || ""),
        content_type: "product",
        quantity: Number(item.quantityPursh || 1),
        price: Number(item.price || 0),
      })),
    });
    metaInitiateCheckout({
      value: subtotal - promoDiscount + prix,
      eventId: metaInitiateCheckoutEventId.current,
      contents: cartDetails.map((item) => ({
        content_id: String(item.id),
        content_name: String(item.name || ""),
        content_type: "product",
        quantity: Number(item.quantityPursh || 1),
        price: Number(item.price || 0),
      })),
    });
  }, [cartDetails, promoDiscount, prix]);

  const isPhoneValid =
    Tel.trim() !== "" &&
    /^[+]?[0-9\s\-\(\)]+$/.test(Tel) &&
    Tel.replace(/[^\d+]/g, "").length >= 8;
  const nameComplete = fullName.trim() !== "";
  const cityComplete = city !== "";
  const deliveryComplete = deliveryType !== "";
  const checkoutStepsTotal = 4;
  const checkoutStepsDone =
    (nameComplete ? 1 : 0) +
    (isPhoneValid ? 1 : 0) +
    (cityComplete ? 1 : 0) +
    (deliveryComplete ? 1 : 0);
  const isCheckoutReady =
    nameComplete && isPhoneValid && cityComplete && deliveryComplete;
  const confirmButtonClass = isCheckoutReady
    ? "bg-pink text-white hover:bg-pink-600 active:scale-[0.99] shadow-md shadow-pink/20"
    : "bg-gray-300 text-gray-500 cursor-not-allowed";
  const checkoutFieldClass = (isComplete: boolean) =>
    `rounded-xl border-2 p-3.5 md:p-3 text-base md:text-sm w-full min-h-[52px] md:min-h-[44px] focus:outline-none focus:ring-2 transition-all duration-300 touch-manipulation ${
      isComplete
        ? "border-green-400 bg-white pr-14 focus:border-green-500 focus:ring-green-200 text-green-900"
        : "border-pink bg-pink-50/80 placeholder:text-pink/40 focus:border-pink focus:ring-pink/20"
    }`;

  
  return (
    <>
      <TopNavThree props="style-three bg-white" />
      <div id="header" className="relative max-sm:mb-5">
        <MenuFurniture props="bg-white" />
      </div>
      <div className="w-full min-h-screen px-3 py-4 overflow-x-hidden">
        {/* Popup Notifications */}
        {showPromoSuccess && (
          <div className="fixed top-4 right-4 z-50 animate-slide-in">
            <div 
              className="popup-notification text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-2 max-w-[85vw] border-2 border-green-700"
              style={{ backgroundColor: '#059669' }}
            >
              <Icon.CheckCircle size={20} className="text-white flex-shrink-0" />
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-sm">Succès !</div>
                <div className="text-xs">{promoMessage}</div>
              </div>
              <button 
                onClick={() => setShowPromoSuccess(false)}
                className="ml-auto text-white hover:text-green-100 flex-shrink-0"
              >
                <Icon.X size={18} />
              </button>
            </div>
          </div>
        )}

        {showPromoError && (
          <div className="fixed top-4 right-4 z-50 animate-slide-in">
            <div 
              className="popup-notification-error text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-2 max-w-[85vw] border-2 border-red-700"
              style={{ backgroundColor: '#dc2626' }}
            >
              <Icon.Warning size={20} className="text-white flex-shrink-0" />
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-sm">Erreur</div>
                <div className="text-xs">{promoMessage}</div>
              </div>
              <button 
                onClick={() => setShowPromoError(false)}
                className="ml-auto text-white hover:text-red-100 flex-shrink-0"
              >
                <Icon.X size={18} />
              </button>
            </div>
          </div>
        )}

        {/* Loading state */}
        {!hasInitialized || isNavigating ? (
          <div className="flex items-center justify-center min-h-[50vh]">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink mx-auto mb-4"></div>
              <p className="text-secondary text-base">Chargement...</p>
            </div>
          </div>
        ) : (
          <>
            <div className="max-w-6xl mx-auto px-2 md:px-4 pb-72 md:pb-0">
              <div className="mb-5 md:mb-6 overflow-hidden rounded-2xl border border-pink/15 bg-gradient-to-br from-pink/10 via-white to-pink/5 px-4 py-5 md:px-6 md:py-6">
                <div className="flex flex-col items-center text-center gap-3">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-pink text-white shadow-md shadow-pink/25">
                    <Icon.ShoppingCartSimple size={26} weight="fill" />
                  </span>
                  <div>
                    <h1 className="text-2xl md:text-3xl font-bold text-pink">Commander</h1>
                    <p className="mt-1 text-sm md:text-base text-secondary max-w-md mx-auto">
                      Remplissez les {checkoutStepsTotal} étapes ci-dessous — c&apos;est rapide.
                    </p>
                  </div>
                  <div className="w-full max-w-xs">
                    <div className="mb-1.5 flex justify-between text-xs font-medium text-secondary">
                      <span>Progression</span>
                      <span className="text-pink">{checkoutStepsDone}/{checkoutStepsTotal}</span>
                    </div>
                    <div className="h-2.5 overflow-hidden rounded-full bg-pink/15">
                      <div
                        className="h-full rounded-full bg-pink transition-all duration-300"
                        style={{ width: `${(checkoutStepsDone / checkoutStepsTotal) * 100}%` }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid lg:grid-cols-2 gap-4 md:gap-6">
                {/* Cart Summary - flat card */}
                <div className="bg-[#f5f5f5] rounded-xl border border-gray-200 p-4 md:p-5 flex flex-col gap-4 order-1 lg:order-2">
                  <h2 className="text-base md:text-lg font-semibold mb-1 text-pink flex items-center gap-2">
                    <Icon.ShoppingBag size={22} weight="duotone" />
                    Votre panier
                  </h2>
                  {cartDetails.length === 0 ? (
                    <div className="text-center text-secondary text-sm md:text-base">Votre panier est vide.</div>
                  ) : (
                    <ul className="divide-y divide-line">
                      {cartDetails.map((product, idx) => (
                        <li key={product.variantKey} className="flex items-start gap-3 py-4 bg-white rounded-lg p-3 border border-gray-100">
                          <img 
                            src={
                              product.colorImageId 
                                ? (product.colorImageId.startsWith('/') ? product.colorImageId : `/images/${product.colorImageId}`)
                                : `/images/${product.id}.jpg`
                            } 
                            alt={product.name} 
                            className="w-16 h-16 object-cover rounded-lg border border-gray-100 flex-shrink-0"
                            onError={(e) => {
                              e.currentTarget.src = "/default.png"; 
                            }}
                          />
                          <div className="flex-1 min-w-0">
                            <div className="font-bold text-title text-sm mb-1 line-clamp-2">{product.name}</div>
                            <div className="flex flex-wrap gap-2 mb-2">
                              <span className="bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded-full">ID: {product.id}</span>
                              {hasSelectedVariantValue(product.sizePursh) && (
                                <span className="bg-blue-100 text-blue-600 text-xs px-2 py-1 rounded-full">T: {product.sizePursh}</span>
                              )}
                              {hasSelectedVariantValue(product.pointurePursh) && (
                                <span className="bg-cyan-100 text-cyan-700 text-xs px-2 py-1 rounded-full">P: {product.pointurePursh}</span>
                              )}
                              {hasSelectedVariantValue(product.colorPursh) && (
                                <span className="bg-purple-100 text-purple-600 text-xs px-2 py-1 rounded-full">C: {product.colorPursh}</span>
                              )}
                          </div>
                            <div className="flex justify-between items-center">
                              <div className="text-xs text-gray-500">
                                Qté: {product.quantityPursh} × {Number(product.price).toFixed(2)} MAD
                              </div>
                              <div className="font-bold text-pink text-sm">
                            {(product.price * product.quantityPursh).toFixed(2)} MAD
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                  {/* Promo Code Section - Desktop Only, compact */}
                  <div className="hidden md:block mt-3">
                    <div className="bg-pink-50/70 border border-pink-100 rounded-lg py-2 px-3">
                      <h3 className="text-sm font-semibold text-pink mb-2 flex items-center gap-1.5">
                        <Icon.Ticket size={16} weight="duotone" className="text-pink" />
                        Code Promo
                      </h3>
                      <PromoCodeInput
                        cartTotal={totalCart}
                        shippingCost={prix}
                        onPromoCodeApplied={handlePromoCodeApplied}
                        onPromoCodeRemoved={handlePromoCodeRemoved}
                        appliedPromoCode={appliedPromoCode || undefined}
                        productIds={cartDetails.map(item => Number(item.id))}
                        categories={cartDetails.map(item => item.category).filter(Boolean)}
                      />
                    </div>
                  </div>

                  {/* Desktop Totals - Hidden on Mobile */}
                  <div className="hidden md:block">
                    <div className="flex justify-between items-center mt-3 md:mt-4 pt-3 md:pt-4 border-t border-line">
                      <span className="font-semibold text-sm md:text-base">Sous-total</span>
                      <span className="font-bold text-base md:text-lg text-pink">{totalCart.toFixed(2)} MAD</span>
                  </div>
                  
                  {/* Promo Code Discount */}
                  {promoDiscount > 0 && (
                    <div className="flex justify-between items-center">
                        <span className="text-green-600 font-medium text-xs md:text-sm">Réduction promo</span>
                        <span className="text-green-600 font-medium text-xs md:text-sm">-{promoDiscount.toFixed(2)} MAD</span>
                    </div>
                  )}
                    {hasFreeShippingPromoCode && (
                      <div className="flex justify-between items-center">
                        <span className="text-green-600 font-medium text-xs md:text-sm">Livraison gratuite</span>
                        <span className="text-green-600 font-medium text-xs md:text-sm">Gratuit</span>
                      </div>
                    )}
                    {deliveryType && !hasFreeShippingPromoCode && (
                      <div className="flex justify-between items-center">
                        <span className="text-secondary text-xs md:text-sm">Frais de livraison</span>
                        <span className="font-medium text-xs md:text-sm">{prix} MAD</span>
                      </div>
                  )}
                  
                  <div className="flex justify-between items-center pt-2 border-t border-line">
                      <span className="font-semibold text-sm md:text-base">Total</span>
                      <span className="font-bold text-base md:text-lg text-pink">{(Number(totalCart) - Number(promoDiscount) + Number(prix)).toFixed(2)} MAD</span>
                    </div>
                  </div>
                </div>
                {/* Checkout Form - flat design */}
                <form id="checkout-form" onSubmit={submitOrder} className="bg-[#f5f5f5] rounded-xl border border-gray-200 p-3 md:p-5 flex flex-col gap-3 md:gap-4 order-2 lg:order-1" noValidate>
                  <h2 className="text-base md:text-lg font-semibold text-pink flex items-center gap-2 px-1">
                    <Icon.User size={22} weight="duotone" />
                    Vos informations
                  </h2>

                  <CheckoutStep
                    step={1}
                    title="Nom complet"
                    subtitle="Comme sur votre pièce d'identité ou carte bancaire"
                    icon={<Icon.User size={18} weight="duotone" />}
                    isComplete={nameComplete}
                  >
                    <CheckoutFieldWrapper isComplete={nameComplete}>
                      <input
                        type="text"
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        className={checkoutFieldClass(nameComplete)}
                        placeholder="Ex : Fatima El Amrani"
                        title="Veuillez saisir votre nom complet"
                        autoComplete="name"
                        required
                      />
                    </CheckoutFieldWrapper>
                  </CheckoutStep>

                  <CheckoutStep
                    step={2}
                    title="Téléphone"
                    subtitle="Pour vous appeler et confirmer la livraison"
                    icon={<Icon.Phone size={18} weight="duotone" />}
                    isComplete={isPhoneValid}
                  >
                    <CheckoutFieldWrapper isComplete={isPhoneValid}>
                      <input
                        type="tel"
                        inputMode="tel"
                        value={Tel}
                        onChange={(e) => setTel(e.target.value)}
                        className={`${checkoutFieldClass(isPhoneValid)} ${
                          Tel.trim() !== "" && !/^[+]?[0-9\s\-\(\)]+$/.test(Tel)
                            ? "!border-red-400 !bg-red-50 !pr-3.5"
                            : Tel.trim() !== "" &&
                                /^[+]?[0-9\s\-\(\)]+$/.test(Tel) &&
                                Tel.replace(/[^\d+]/g, "").length < 8
                              ? "!border-red-400 !bg-red-50 !pr-3.5"
                              : ""
                        }`}
                        placeholder="Ex : 06 12 34 56 78"
                        title="Veuillez saisir un numéro de téléphone valide"
                        autoComplete="tel"
                        required
                      />
                    </CheckoutFieldWrapper>
                    {Tel.trim() !== "" && !/^[+]?[0-9\s\-\(\)]+$/.test(Tel) && (
                      <p className="mt-2 text-sm text-red-500">Chiffres et « + » uniquement</p>
                    )}
                    {Tel.trim() !== "" &&
                      /^[+]?[0-9\s\-\(\)]+$/.test(Tel) &&
                      Tel.replace(/[^\d+]/g, "").length < 8 && (
                        <p className="mt-2 text-sm text-red-500">Au moins 8 chiffres</p>
                      )}
                  </CheckoutStep>

                  <CheckoutStep
                    step={3}
                    title="Ville"
                    subtitle="Choisissez votre ville de livraison"
                    icon={<Icon.MapTrifold size={18} weight="duotone" />}
                    isComplete={cityComplete}
                  >
                    <CheckoutFieldWrapper isComplete={cityComplete}>
                      <select
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        className={`${checkoutFieldClass(cityComplete)} appearance-none cursor-pointer ${
                          cityComplete
                            ? "pr-14"
                            : "bg-[url('data:image/svg+xml;charset=UTF-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2224%22 height=%2224%22 viewBox=%220 0 256 256%22%3E%3Cpath fill=%22%23FF4370%22 d=%22M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80a8,8,0,0,1,11.32-11.32L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z%22/%3E%3C/svg%3E')] bg-[length:20px] bg-[right_12px_center] bg-no-repeat pr-10"
                        }`}
                        title="Veuillez sélectionner une ville"
                        required
                      >
                        <option value="">Appuyez pour choisir une ville</option>
                        {livraison.map((cityItem) => (
                          <option key={cityItem.id} value={cityItem.city}>
                            {cityItem.city}
                          </option>
                        ))}
                      </select>
                    </CheckoutFieldWrapper>
                  </CheckoutStep>

                  {/* Delivery Options */}
                  {city &&
                    livraison
                      .filter((e) => e.city === city)
                      .map((cityData) => (
                        <CheckoutStep
                          key={cityData.id}
                          step={4}
                          title="Mode de livraison"
                          subtitle={`Options disponibles pour ${cityData.city}`}
                          icon={<Icon.Truck size={18} weight="duotone" />}
                          isComplete={deliveryComplete}
                        >
                          {deliveryPromoActive && (
                            <p className="mb-3 rounded-lg bg-green-50 px-3 py-2 text-sm text-green-700">
                              Livraison offerte pour ce produit (panier à un seul article).
                            </p>
                          )}
                          <div className="space-y-3">
                            <label
                              className={`relative flex min-h-[56px] cursor-pointer items-center gap-3 rounded-xl border-2 p-3.5 transition-all duration-300 touch-manipulation ${
                                deliveryType === "standard"
                                  ? "border-green-500 bg-green-50 ring-1 ring-green-200"
                                  : "border-pink/30 bg-white hover:border-pink/50 hover:bg-pink-50/50"
                              }`}
                            >
                              {deliveryType === "standard" && (
                                <span className={`absolute right-3 top-1/2 h-8 w-8 -translate-y-1/2 ${checkoutCompleteMarkClass}`}>
                                  <Icon.Check size={18} weight="bold" className="text-green-600" />
                                </span>
                              )}
                              <input
                                type="radio"
                                name="deliveryType"
                                value="standard"
                                checked={deliveryType === "standard"}
                                onChange={() => delivery("standard", cityData.standard)}
                                className="h-5 w-5 shrink-0 text-pink focus:ring-pink"
                                required
                              />
                              <div className={`flex-1 min-w-0 ${deliveryType === "standard" ? "pr-10" : ""}`}>
                                <div className={`font-semibold text-base md:text-sm ${deliveryType === "standard" ? "text-green-800" : ""}`}>
                                  Livraison Standard
                                </div>
                                <div className="text-sm text-secondary">
                                  {resolveCheckoutShippingFee(
                                    cityData.standard,
                                    cartDetails,
                                    deliveryPromoProductIds,
                                    hasFreeShippingPromoCode
                                  )}{" "}
                                  MAD
                                </div>
                              </div>
                            </label>
                            {cityData.express > 0 && (
                              <label
                                className={`relative flex min-h-[56px] cursor-pointer items-center gap-3 rounded-xl border-2 p-3.5 transition-all duration-300 touch-manipulation ${
                                  deliveryType === "express"
                                    ? "border-green-500 bg-green-50 ring-1 ring-green-200"
                                    : "border-pink/30 bg-white hover:border-pink/50 hover:bg-pink-50/50"
                                }`}
                              >
                                {deliveryType === "express" && (
                                  <span className={`absolute right-3 top-1/2 h-8 w-8 -translate-y-1/2 ${checkoutCompleteMarkClass}`}>
                                    <Icon.Check size={18} weight="bold" className="text-green-600" />
                                  </span>
                                )}
                                <input
                                  type="radio"
                                  name="deliveryType"
                                  value="express"
                                  checked={deliveryType === "express"}
                                  onChange={() => delivery("express", cityData.express)}
                                  className="h-5 w-5 shrink-0 text-pink focus:ring-pink"
                                  required
                                />
                                <div className={`flex-1 min-w-0 ${deliveryType === "express" ? "pr-10" : ""}`}>
                                  <div className={`font-semibold text-base md:text-sm ${deliveryType === "express" ? "text-green-800" : ""}`}>
                                    Livraison Express
                                  </div>
                                  <div className="text-sm text-secondary">
                                    {resolveCheckoutShippingFee(
                                      cityData.express,
                                      cartDetails,
                                      deliveryPromoProductIds,
                                      hasFreeShippingPromoCode
                                    )}{" "}
                                    MAD
                                  </div>
                                </div>
                              </label>
                            )}
                          </div>
                          {deliveryType === "" && (
                            <p className="mt-3 text-sm font-medium text-pink">
                              Appuyez sur une option ci-dessus
                            </p>
                          )}
                        </CheckoutStep>
                      ))}

                  {/* Paiement — toujours à la livraison */}
                  <CheckoutStep
                    step={5}
                    title="Paiement"
                    subtitle="Payez en espèces à la réception"
                    icon={<Icon.Money size={18} weight="duotone" />}
                    isComplete={true}
                  >
                    <label className="relative flex min-h-[56px] cursor-default items-center gap-3 rounded-xl border-2 border-green-500 bg-green-50 p-3.5 ring-1 ring-green-200 touch-manipulation">
                      <span className={`absolute right-3 top-1/2 h-8 w-8 -translate-y-1/2 ${checkoutCompleteMarkClass}`}>
                        <Icon.Check size={18} weight="bold" className="text-green-600" />
                      </span>
                      <input
                        type="radio"
                        name="paymentMethod"
                        checked
                        readOnly
                        className="h-5 w-5 shrink-0 text-pink focus:ring-pink"
                      />
                      <div className="min-w-0 flex-1 pr-10">
                        <div className="text-base font-semibold text-green-800 md:text-sm">
                          Paiement à la livraison
                        </div>
                        <div className="text-sm text-secondary">Payez en espèces à la réception.</div>
                      </div>
                    </label>
                  </CheckoutStep>
                  {/* Submit Button - flat */}
                  <button 
                    type="submit" 
                    disabled={isSubmitting || !isCheckoutReady}
                    className={`hidden md:flex w-full font-bold py-4 px-4 rounded-xl mt-2 items-center justify-center gap-2 text-base border-0 transition-all duration-300 min-h-[52px] disabled:opacity-70 disabled:cursor-not-allowed ${confirmButtonClass}`}
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent" />
                        <span>Envoi en cours...</span>
                      </>
                    ) : isCheckoutReady ? (
                      <>
                        <Icon.CheckCircle size={22} weight="duotone" />
                        <span>Confirmer la commande</span>
                      </>
                    ) : (
                      <>
                        <Icon.Lock size={22} weight="duotone" />
                        <span>Complétez les {checkoutStepsTotal} étapes</span>
                      </>
                    )}
                  </button>
                </form>
              </div>
            </div>
          </>
        )}
        


        {/* Mobile Sticky Bottom Section - flat */}
        <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t-2 border-gray-200 z-50 shadow-[0_-8px_30px_-12px_rgba(0,0,0,0.15)]">
          <div className="px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
            {/* Compact Promo Code Section */}
            <details className="mb-3 group">
              <summary className="flex cursor-pointer list-none items-center justify-between rounded-xl border-2 border-gray-200 bg-gray-50 px-3 py-2.5 text-sm font-medium text-secondary touch-manipulation [&::-webkit-details-marker]:hidden">
                <span className="flex items-center gap-2">
                  <Icon.Ticket size={18} weight="duotone" className="text-pink" />
                  Code promo {appliedPromoCode ? `(✓ ${appliedPromoCode.code})` : ""}
                </span>
                <Icon.CaretDown size={18} className="text-pink transition-transform group-open:rotate-180" />
              </summary>
              <div className="mt-2 rounded-xl border-2 border-gray-200 bg-white p-3">
              <div className="flex gap-2">
                <input
                  type="text"
                  placeholder="Entrez votre code"
                  className="flex-1 min-h-[48px] border-2 border-gray-200 rounded-xl px-3 py-2 text-base focus:outline-none focus:border-pink focus:ring-2 focus:ring-pink/20 bg-white touch-manipulation"
                  value={promoCode || ''}
                  onChange={(e) => setPromoCode(e.target.value.toUpperCase())}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleApplyPromoCode();
                    }
                  }}
                />
                <button
                  onClick={handleApplyPromoCode}
                  disabled={!promoCode?.trim() || isLoading}
                  className="bg-pink text-white px-4 py-2 rounded-xl border-0 hover:bg-pink-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-sm font-semibold flex items-center justify-center min-w-[52px] min-h-[48px] touch-manipulation"
                >
                  {isLoading ? (
                    <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                  ) : (
                    <Icon.Check size={18} weight="bold" />
                  )}
                </button>
      </div>
              
              {appliedPromoCode && (
                <div className="mt-2 p-2.5 bg-green-50 border border-green-200 rounded-lg text-green-700 text-sm flex items-center justify-between">
                  <span>✓ {appliedPromoCode.code} (-{promoDiscount.toFixed(2)} MAD)</span>
                  <button
                    onClick={handlePromoCodeRemoved}
                    className="text-red-500 hover:text-red-700 ml-2 p-1 touch-manipulation"
                    aria-label="Retirer le code promo"
                  >
                    <Icon.X size={16} />
                  </button>
                </div>
              )}
              
              {error && (
                <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                  {error}
                </div>
              )}
              </div>
            </details>

            {/* Summary Section - compact */}
            <div className="flex justify-between items-center mb-1">
              <span className="text-sm text-gray-600">
                Total · {checkoutStepsDone}/{checkoutStepsTotal} étapes
              </span>
              <span className="text-xl font-bold text-pink">{(totalCart - promoDiscount + prix).toFixed(2)} MAD</span>
            </div>
            {promoDiscount > 0 && (
              <div className="flex justify-between items-center mb-2 text-sm text-green-600">
                <span>Réduction promo</span>
                <span>-{promoDiscount.toFixed(2)} MAD</span>
              </div>
            )}
            
            {/* Fixed Order Button */}
            <button 
              onClick={(e) => {
                e.preventDefault();
                if (!isCheckoutReady || isSubmitting) return;
                submitOrder(e as any);
              }}
              disabled={isSubmitting || !isCheckoutReady}
              className={`w-full font-bold py-4 rounded-xl transition-all duration-300 text-base flex items-center justify-center gap-2 min-h-[56px] touch-manipulation disabled:opacity-70 disabled:cursor-not-allowed ${confirmButtonClass}`}
            >
              {isSubmitting ? (
                <>
                  <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                  <span>Envoi en cours...</span>
                </>
              ) : isCheckoutReady ? (
                <>
                  <Icon.CheckCircle size={22} weight="fill" />
                  <span>Confirmer la commande</span>
                </>
              ) : (
                <>
                  <Icon.Lock size={22} weight="duotone" />
                  <span>Complétez les {checkoutStepsTotal} étapes</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      <div className="hidden md:block">
      <Footer />
      </div>
    </>
  );
};

export default Checkout;

